import type { LandingLocale } from './landingMarketingCopy';

type Props = {
  locale: LandingLocale;
  label: string;
  langVi: string;
  langEn: string;
  onChange: (locale: LandingLocale) => void;
};

function GlobeIcon(): JSX.Element {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M3 12h18M12 3c2.5 2.8 2.5 14.2 0 18M12 3c-2.5 2.8-2.5 14.2 0 18"
        stroke="currentColor"
        strokeWidth="1.75"
      />
    </svg>
  );
}

export default function LandingLanguageSwitcher({
  locale,
  label,
  langVi,
  langEn,
  onChange,
}: Props): JSX.Element {
  return (
    <div className="lang-switch" role="group" aria-label={label}>
      <span className="lang-switch-icon" title={label}>
        <GlobeIcon />
      </span>
      <button
        type="button"
        className={`lang-switch-btn${locale === 'vi' ? ' is-active' : ''}`}
        aria-pressed={locale === 'vi'}
        onClick={() => onChange('vi')}
      >
        VI
      </button>
      <button
        type="button"
        className={`lang-switch-btn${locale === 'en' ? ' is-active' : ''}`}
        aria-pressed={locale === 'en'}
        onClick={() => onChange('en')}
      >
        EN
      </button>
      <span className="lang-switch-hint">{locale === 'vi' ? langVi : langEn}</span>
    </div>
  );
}
